
function Menu () {
    return (
        <img className="menuImage" src="/images/menu.jpg" alt=""/>
    )
}


export default Menu;
